/**
 * @desc 订单备注列表
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(params: API.omsFlow.systemOrderRemark.list.Params, options?: any) {
  return updateResponse(
    http(URL + `/systemOrderRemark/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
